/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AllocationDetailsSearchParams
} from '../../model/allocationDetailsSearchParams'
import type {
  AllocationLookupSearchDataRequest
} from '../../model/allocationLookupSearchDataRequest'
import type {
  AllocationLookupSearchDataResultList
} from '../../model/allocationLookupSearchDataResultList'
import type {
  AllocationRuleChooseInvestingEntityDataList
} from '../../model/allocationRuleChooseInvestingEntityDataList'
import type {
  AllocationRuleLookupBulkCreateAPIDataRequest
} from '../../model/allocationRuleLookupBulkCreateAPIDataRequest'
import type {
  AllocationRuleLookupReadDataList
} from '../../model/allocationRuleLookupReadDataList'
import type {
  EntityAllocationRulesRetrieveParams
} from '../../model/entityAllocationRulesRetrieveParams'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Creates an allocation graph mapping
 */
export const createAllocationRuleLookup = (
    fundFamilyId: string,
    allocationRuleLookupBulkCreateAPIDataRequest: AllocationRuleLookupBulkCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AllocationRuleLookupReadDataList>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-lookup/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationRuleLookupBulkCreateAPIDataRequest
    },
      options);
    }
  


export const getCreateAllocationRuleLookupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAllocationRuleLookup>>, TError,{fundFamilyId: string;data: AllocationRuleLookupBulkCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createAllocationRuleLookup>>, TError,{fundFamilyId: string;data: AllocationRuleLookupBulkCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAllocationRuleLookup>>, {fundFamilyId: string;data: AllocationRuleLookupBulkCreateAPIDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  createAllocationRuleLookup(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAllocationRuleLookupMutationResult = NonNullable<Awaited<ReturnType<typeof createAllocationRuleLookup>>>
    export type CreateAllocationRuleLookupMutationBody = AllocationRuleLookupBulkCreateAPIDataRequest
    export type CreateAllocationRuleLookupMutationError = unknown

    export const useCreateAllocationRuleLookup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAllocationRuleLookup>>, TError,{fundFamilyId: string;data: AllocationRuleLookupBulkCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreateAllocationRuleLookupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a list of allocation rules for a given entity
 */
export const entityAllocationRulesRetrieve = (
    fundFamilyId: string,
    params?: EntityAllocationRulesRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AllocationRuleChooseInvestingEntityDataList>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-lookup/entity-allocation-rules/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getEntityAllocationRulesRetrieveQueryKey = (fundFamilyId: string,
    params?: EntityAllocationRulesRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-lookup/entity-allocation-rules/`, ...(params ? [params]: [])] as const;
    }

    
export const getEntityAllocationRulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: EntityAllocationRulesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEntityAllocationRulesRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>> = ({ signal }) => entityAllocationRulesRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type EntityAllocationRulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>>
export type EntityAllocationRulesRetrieveQueryError = unknown

export const useEntityAllocationRulesRetrieve = <TData = Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: EntityAllocationRulesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEntityAllocationRulesRetrieveQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getEntityAllocationRulesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError = unknown>(fundFamilyId: string,
    params?: EntityAllocationRulesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEntityAllocationRulesRetrieveQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>> = ({ signal }) => entityAllocationRulesRetrieve(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type EntityAllocationRulesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>>
export type EntityAllocationRulesRetrieveSuspenseQueryError = unknown

export const useEntityAllocationRulesRetrieveSuspense = <TData = Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    params?: EntityAllocationRulesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof entityAllocationRulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getEntityAllocationRulesRetrieveSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getEntityAllocationRulesRetrieveLoader = (queryParamsOrFn?: (EntityAllocationRulesRetrieveParams | ((params: Params) => EntityAllocationRulesRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getEntityAllocationRulesRetrieveQueryKey(fundFamilyId, queryParams),
              queryFn: () => entityAllocationRulesRetrieve(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets Allocation Details for a specified set of transaction code/investment pairs
 */
export const allocationDetailsSearch = (
    fundFamilyId: string,
    allocationLookupSearchDataRequest: AllocationLookupSearchDataRequest,
    params: AllocationDetailsSearchParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AllocationLookupSearchDataResultList>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-lookup/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationLookupSearchDataRequest,
        params
    },
      options);
    }
  


export const getAllocationDetailsSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationDetailsSearch>>, TError,{fundFamilyId: string;data: AllocationLookupSearchDataRequest;params: AllocationDetailsSearchParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationDetailsSearch>>, TError,{fundFamilyId: string;data: AllocationLookupSearchDataRequest;params: AllocationDetailsSearchParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationDetailsSearch>>, {fundFamilyId: string;data: AllocationLookupSearchDataRequest;params: AllocationDetailsSearchParams}> = (props) => {
          const {fundFamilyId,data,params} = props ?? {};

          return  allocationDetailsSearch(fundFamilyId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationDetailsSearchMutationResult = NonNullable<Awaited<ReturnType<typeof allocationDetailsSearch>>>
    export type AllocationDetailsSearchMutationBody = AllocationLookupSearchDataRequest
    export type AllocationDetailsSearchMutationError = unknown

    export const useAllocationDetailsSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationDetailsSearch>>, TError,{fundFamilyId: string;data: AllocationLookupSearchDataRequest;params: AllocationDetailsSearchParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationDetailsSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets TableData of Allocation Overrides
 */
export const fundFamilyTransactionAllocationOverride = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-lookup/transaction-overrides`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyTransactionAllocationOverrideQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-lookup/transaction-overrides`] as const;
    }

    
export const getFundFamilyTransactionAllocationOverrideQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyTransactionAllocationOverrideQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>> = ({ signal }) => fundFamilyTransactionAllocationOverride(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyTransactionAllocationOverrideQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>>
export type FundFamilyTransactionAllocationOverrideQueryError = unknown

export const useFundFamilyTransactionAllocationOverride = <TData = Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyTransactionAllocationOverrideQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyTransactionAllocationOverrideSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyTransactionAllocationOverrideQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>> = ({ signal }) => fundFamilyTransactionAllocationOverride(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyTransactionAllocationOverrideSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>>
export type FundFamilyTransactionAllocationOverrideSuspenseQueryError = unknown

export const useFundFamilyTransactionAllocationOverrideSuspense = <TData = Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyTransactionAllocationOverride>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyTransactionAllocationOverrideSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyTransactionAllocationOverrideLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyTransactionAllocationOverrideQueryKey(fundFamilyId),
              queryFn: () => fundFamilyTransactionAllocationOverride(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      